<div class="section">
  <h3>{{ 'COMMON.SUMMARY' | translate }}</h3>
  <p>{{ summary() }}</p>
</div>

<div class="section">
  <h3>{{ 'COMMON.KEY_TAKEAWAYS' | translate }}</h3>
  <ul>
    <li *ngFor="let takeaway of keyTakeaways()">{{ takeaway }}</li>
  </ul>
</div>

<div class="section">
  <h3>{{ 'COMMON.ACTION_ITEMS' | translate }}</h3>
  <ul>
    <li *ngFor="let item of actionItems()">{{ item }}</li>
  </ul>
</div>
